// Глобальный флаг «идёт роут-навигация» — источник истины для верхней
// полосы-индикатора (GlobalNavigationProgress.vue).
//
// Зачем: при SPA-переходе (напр. со страницы наставника в «Мой профиль») между
// кликом и первым рендером целевой страницы проходит время — гард beforeEach
// ждёт fetchUser, beforeEnter тянет by-slug и т.п. Без индикатора пользователь
// ~2с смотрит на старую страницу и думает, что клик «не сработал». Роутер
// поднимает флаг в beforeEach (сразу, синхронно) и опускает в afterEach/onError.
//
// Модель — БУЛЕВА, а не счётчик: цепочка редиректов в глобальном beforeEach
// (attribution/landing/auth) вызывает start несколько раз, но afterEach
// срабатывает один раз на финальную навигацию. Счётчик бы «завис» на >0;
// булев флаг всегда приходит к false по последнему событию (afterEach/onError).

import { ref, readonly, type DeepReadonly, type Ref } from 'vue';

const navigating = ref(false);

/** Реактивный флаг «идёт навигация» (только чтение) для компонента-полоски. */
export const isNavigating: DeepReadonly<Ref<boolean>> = readonly(navigating);

/** Начало навигации — вызывается первой строкой router.beforeEach. */
export function startNavigation(): void {
    navigating.value = true;
}

/** Конец навигации — router.afterEach и router.onError. */
export function stopNavigation(): void {
    navigating.value = false;
}

/** Хард-сброс (тест-хелпер / аварийное гашение). */
export function resetNavigation(): void {
    navigating.value = false;
}
